import { Box, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { LocalizedStrict } from "../../../../../../../localization/components/AppLocalized"

const useStyles = makeStyles()((theme) => ({
    noDataContainer: {
        padding: "1rem 2rem 3rem",
        flexDirection: "column",
        background: "white",
        borderRadius: ".75rem",
        textAlign: "center",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    noMenuTitle: {
        color: theme.palette.tailwind.slate[700],
        fontWeight: 600,
        marginBottom: "0.5rem",
    },
    noMenuDescription: {
        color: theme.palette.tailwind.slate[400],
        fontWeight: 600,
        marginBottom: "0.5rem",
    },
}))

export const NoMenu = () => {
    const { classes } = useStyles()

    return (
        <Box className={classes.noDataContainer}>
            <LocalizedStrict id="user-home-week-menu-no-menus-title">
                <Typography variant="h6" className={classes.noMenuTitle}>
                    No menu available
                </Typography>
            </LocalizedStrict>
            <LocalizedStrict id="user-home-week-menu-no-menus">
                <Typography variant="body2" className={classes.noMenuDescription}>
                    Unfortunately, no menus have been created this week.
                </Typography>
            </LocalizedStrict>
        </Box>
    )
}
